import { useMediaUrl } from '@/services/media';

interface Props extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  episodeUuid: string;
  path: string;
}

/**
 * <img> wrapper that resolves both same-origin Laravel paths and idb://
 * local-mode blob refs. Use this anywhere a generated image is rendered.
 */
export function MediaImage({ episodeUuid, path, alt = '', ...rest }: Props) {
  const src = useMediaUrl(episodeUuid, path);
  if (!src) {
    return <span className="block h-full w-full bg-surface-2" aria-hidden="true" />;
  }
  return <img src={src} alt={alt} {...rest} />;
}
